'use client'

import React, { useEffect, useState } from 'react'
import { ImCross } from 'react-icons/im'
import type { StickyBannerFragment } from '../../../.graphql/generated-types'
import { notEmpty } from '@marketing-sites/utils'
import { ComposeComponentStickyBannerItem } from '../ComposeComponentStickyBannerItem'

export interface StickyBannerProps {
  data: StickyBannerFragment
}

export function StickyBanner({ data }: StickyBannerProps) {
  const [isClosed, setIsClosed] = useState(false)
  const [listLength, setListLength] = useState(0)
  const [currentItemIndex, setCurrentItemIndex] = useState(0)
  useEffect(() => {
    setListLength(data.itemsCollection?.items.length ?? 0)
  }, [data.itemsCollection?.items.length])
  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentItemIndex((currentItemIndex + 1) % listLength)
    }, 5000)
    return () => {
      clearTimeout(timer)
    }
  }, [listLength, currentItemIndex])
  const close = () => {
    setIsClosed(true)
  }
  if (!isClosed && data.name && data.itemsCollection?.items) {
    const items = data.itemsCollection.items.filter(notEmpty)
    return (
      <div className="fixed bottom-0 z-10 w-screen">
        {items.map((item, i) => {
          const isCurrent = i === currentItemIndex
          return (
            <div
              key={i}
              className={`absolute bottom-0 bg-red-500 ${
                isCurrent ? 'z-10 bg-opacity-80 opacity-100' : 'z-0 opacity-0'
              } w-full p-1 transition-all duration-1000`}
            >
              <button
                aria-label="Close Banner"
                className="absolute right-5 top-2 flex h-8 w-8 flex-row-reverse text-white"
                onClick={close}
              >
                <ImCross size={12} />
              </button>
              <div
                className={`z-10 text-white ${
                  isCurrent ? 'opacity-100' : 'opacity-0'
                } transition-opacity delay-200 duration-1000 ease-linear`}
              >
                <ComposeComponentStickyBannerItem data={item} />
              </div>
            </div>
          )
        })}
      </div>
    )
  }
  return null
}
